import { CircularProgress } from '@mui/material';
import styles from './main.module.scss';

const Main: React.FC = () => {
	return (
		<section className={styles.wrapper}>
			<CircularProgress color='primary' />
		</section>
	);
};

export default Main;
